export default "__VITE_ASSET__sILFxFWr__"